import { Injectable } from "@angular/core";
import { EmailModel } from "../models/email.model";

@Injectable({
    providedIn: "root",
})
export class SoEmailContentBuilderService {

    constructor(){}

    getEmailContent(data: any): EmailModel {
        const attachmentName = data?.type + "_" + data?.number;
        const obj = {
            name: attachmentName + ".pdf",
            attachment: data?.attachment,
            extension: ".pdf",
        };
        let emailData : EmailModel = {
            emailDialogHeader: `Send ${ data?.type } Email`,
            emailSubject:  data?.type + " " + data?.number,
            emailTo: data?.emailTo,
            emailContent: this.getEmailBody(data?.customerName ?? "",  data?.type, data?.organizationName),
            emailAttachments: [obj],
        }
        return emailData;
    }
    
    getEmailBody(customerName, moduleName, organizationName) {
        let emailContent = `
                <p>Dear ${customerName},</p><br/>
                <p>Please review the attached ${moduleName}. Feel free to contact us if you have any questions.</p><br/>
                <p>We look forward to working with you.</p><br/><br/><p>Sincerely,</p><br/>
                <p>${organizationName}</p><br/><p>${""}</p>`;
        return emailContent;
    }

}